// extracted by mini-css-extract-plugin
export default {"activeField":"Template_activeField__JTiSg","notActive":"Template_notActive__iS5EF"};